
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/revoke",
      function () {
        return require("private-next-pages/revoke.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/revoke"])
      });
    }
  